import fetch from "../fetch";

export default ({ propertyId }) =>
  fetch({
    method: "DELETE",
    path: `/re/prop-masters/${propertyId}`
  });
